import { useQuery } from '@apollo/client';
import { ContactPageOutlined } from '@mui/icons-material';
import { Widget, WidgetContent, WidgetHeader, WidgetIcon, useScrollIntoView } from '@procureai/ui-mui';
import { isEmpty } from 'ramda';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { I18nNamespace } from '~/common/types';
import { CircularProgressCentered } from '~/components/CircularProgressCentered/CircularProgressCentered';
import { DataGridCustom } from '~/components/DataGridCustom';
import { PlaceholderWidget } from '~/components/PlaceholderWidget/PlaceholderWidget';
import { RouteId } from '~/routes';

import { useCountryReportListGridConfig } from './CountryReportListWidget.dataGrid';
import { COUNTRY_REPORT_LIST_WIDGET_QUERY } from './CountryReportListWidget.gql';

const WIDGET_NAME = 'CountryReportListWidget';

export const CountryReportListWidget = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(I18nNamespace.riskSustainability, { keyPrefix: WIDGET_NAME });
  const [widgetRef, active] = useScrollIntoView({ hash: 'risk-country-report-list' });
  const { data, loading } = useQuery(COUNTRY_REPORT_LIST_WIDGET_QUERY);
  const config = useCountryReportListGridConfig();
  const reports = data?.cataclysm?.countryReports ?? [];
  return (
    <Widget ref={widgetRef} active={active} data-intercom-target={WIDGET_NAME}>
      <WidgetHeader title={t('title')} icon={<WidgetIcon icon={<ContactPageOutlined fontSize="small" />} />} />
      <WidgetContent sx={{ minHeight: 400 }}>
        {!isEmpty(reports) ? (
          <DataGridCustom
            {...config}
            rows={reports}
            getRowId={(row) => row.id}
            pagination={true}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            onCellClick={({ row }) => navigate(RouteId.riskCountryReportDetail(row.id))}
            hideFooter={false}
            pageSizeOptions={[5]}
          />
        ) : loading ? (
          <CircularProgressCentered sx={{ position: 'relative' }} />
        ) : (
          <PlaceholderWidget />
        )}
      </WidgetContent>
    </Widget>
  );
};
